var _defs, _rect, _rect2, _path, _text, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _text2, _text3, _text4, _text5, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _text35, _text36, _text37, _text38, _text39, _text40, _text41, _text42, _text43, _text44, _text45, _text46, _text47, _text48, _text49, _text50, _text51, _text52, _text53, _text54, _text55, _text56, _text57, _text58, _text59, _text60, _text61, _text62, _text63, _text64, _text65, _text66, _text67, _text68, _text69, _text70, _text71, _text72, _text73, _text74, _text75, _text76, _text77, _text78, _text79, _text80, _text81, _text82, _text83, _text84, _text85, _text86, _text87, _text88, _text89, _text90, _text91, _text92, _text93, _text94, _text95, _text96, _text97, _text98, _text99, _text100, _text101, _text102, _text103, _text104, _text105, _text106, _text107, _text108, _text109, _text110, _text111, _text112, _text113, _text114, _text115, _text116, _text117, _text118, _text119;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrp5SpeedscaleHigh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b1313574-305a-498a-aee0-2c1133f231ca",
    "data-name": "Card 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.2 840.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".crp5_105,.crp5_86,.crp5_99,.crp5_100,.crp5_90,.crp5_101{fill:none;stroke-miterlimit:10}.crp5_86,.crp5_90{stroke:#000}.crp5_101{stroke-width:0.5px}.crp5_99,.crp5_90{stroke-width:1.5px}.crp5_97{font-size:9.76px}.crp5_102,.crp5_97,.crp5_104{fill:#1d1d1b}.crp5_105,.crp5_102,.crp5_97,.crp5_104{font-family:HelveticaNeue-Condensed, Helvetica Neue}.crp5_99,.crp5_100,.crp5_101{stroke:#1d1d1b}.crp5_102{font-size:11.32px}.crp5_105,.crp5_104{font-size:11.32px}.crp5_105{stroke:#fff;stroke-width:3px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.79,
    y: 62.59,
    width: 327.21,
    height: 715.83,
    rx: 25.23,
    ry: 25.23,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131.79,
    y: 62.59,
    width: 327.21,
    height: 715.83,
    rx: 25.23,
    ry: 25.23,
    strokeWidth: 0.5,
    stroke: "#000",
    fill: "none",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "crp5_90",
    d: "M132.94 753.55h7.4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(148.96 119.13) rotate(-90)"
  }, "30")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_86",
    d: "M132.94 732.28h9.94M132.94 711.28h9.94M132.94 689.28h9.94M132.94 668.28h9.94M132.94 646.68h16.02M132.94 625.68h9.94M132.94 604.28h9.94M132.94 582.28h9.94M132.94 561.28h9.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_90",
    d: "M132.94 540.68h8.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_86",
    d: "M132.94 519.28h9.94M132.94 498.28h9.94M132.94 476.28h9.94M132.94 455.28h9.94M132.94 433.68h16.02M132.94 412.68h9.94M132.94 391.28h9.94M132.94 369.28h9.94M132.94 348.28h9.94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_90",
    d: "M132.94 327.68h8.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_86",
    d: "M132.94 306.28h9.94M132.94 285.28h9.94M132.94 263.28h9.94M132.94 242.28h9.94M132.94 220.68h16.02M132.94 199.68h9.94M132.94 178.28h9.94M132.94 156.28h9.94M132.94 135.28h9.94"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_90",
    d: "M132.94 114.68h8.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_86",
    d: "M132.94 93.28h9.94"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(148.96 332.13) rotate(-90)"
  }, "20")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(148.96 545.13) rotate(-90)"
  }, "10")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(148.96 756.13) rotate(-90)"
  }, "0")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(149.46 741.41) rotate(-90)",
    fontSize: 7.42,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#1d1d1b"
  }, "nm l:250 000")), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M152 94.76s62.17-14.67 143.4-14.67S439 94.76 439 94.76v613.67H152zM438.96 708.43v69.48M151.96 708.43v69.45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M152 130.92s67.38-15.5 143.44-15.5S439 130.92 439 130.92M152 167.92s67.38-16.5 143.44-16.5S439 167.92 439 167.92M152 205.17s67.38-17.75 143.44-17.75S439 205.17 439 205.17M152 241.17s67.38-17.75 143.44-17.75S439 241.17 439 241.17M152 279.17s67.38-20.25 143.44-20.25S439 279.17 439 279.17M152 316.17s67.38-20.25 143.44-20.25S439 316.17 439 316.17M152 354.17s67.38-23.25 143.44-23.25S439 354.17 439 354.17M152 392.17s67.38-25 143.44-25 143.56 25 143.56 25M152 430.92s67.38-27.75 143.44-27.75S439 430.92 439 430.92M152 469.17s67.38-30 143.44-30 143.56 30 143.56 30M152 508.92s67.38-34.75 143.44-34.75S439 508.92 439 508.92M152 548.92s67.38-37.75 143.44-37.75S439 548.92 439 548.92"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M152 592.17s55.88-45.75 143.44-45.75S439 591.17 439 591.17"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M152 637.92s55.88-55.5 143.44-55.5S439 637.92 439 637.92"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M152 691.17s47.38-73 143.44-73S439 689.28 439 689.28"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M183.46 708.43s40.5-55 112-55 113.5 55 113.5 55"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M235.71 708.43s24.13-19.15 59.69-19.15 62.06 19.15 62.06 19.15M151.96 746.17h287M183.46 778.42v-69.5M220.96 778.42v-69.99M257.96 778.42v-69.99M295.4 778.42v-69.99M332.71 778.42v-69.99M369.96 778.42v-69.99M407.71 778.42v-69.99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 123.92s67.38-15.5 143.44-15.5S439 123.92 439 123.92"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 116.92s67.38-15.5 143.44-15.5S439 116.92 439 116.92"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 108.92s67.38-15.5 143.44-15.5S439 108.92 439 108.92"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 101.92s67.38-15.5 143.44-15.5S439 101.92 439 101.92M152 159.92s67.38-16.5 143.44-16.5S439 159.92 439 159.92"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 152.92s67.38-16.5 143.44-16.5S439 152.92 439 152.92"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 145.17s67.38-15.75 143.44-15.75S439 145.17 439 145.17"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 137.42s67.38-15 143.44-15 143.56 15 143.56 15M152 198.17s67.38-17.75 143.44-17.75S439 198.17 439 198.17"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 190.17s67.38-16.75 143.44-16.75S439 190.17 439 190.17"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 183.17s67.38-16.75 143.44-16.75S439 183.17 439 183.17"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 175.67s67.38-17.25 143.44-17.25S439 175.67 439 175.67M152 212.17s67.38-17.75 143.44-17.75S439 212.17 439 212.17"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 219.17s67.38-17.75 143.44-17.75S439 219.17 439 219.17"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 227.17s67.38-17.75 143.44-17.75S439 227.17 439 227.17"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 234.17s67.38-17.75 143.44-17.75S439 234.17 439 234.17M152 271.42s67.38-19.5 143.44-19.5S439 271.42 439 271.42"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 264.42s67.38-19.5 143.44-19.5S439 264.42 439 264.42"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 256.42s67.38-19.5 143.44-19.5S439 256.42 439 256.42"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 249.42s67.38-19.5 143.44-19.5S439 249.42 439 249.42M152 285.67s67.38-19.75 143.44-19.75S439 285.67 439 285.67"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 293.67s67.38-21 143.44-21 143.56 21 143.56 21"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 300.67s67.38-20 143.44-20 143.56 20 143.56 20"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 308.17s67.38-20.5 143.44-20.5S439 308.17 439 308.17"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 323.17s67.38-20.5 143.44-20.5S439 323.17 439 323.17"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 331.17s67.38-22 143.44-22 143.56 22 143.56 22"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 338.17s67.38-22 143.44-22 143.56 22 143.56 22"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 346.17s67.38-22.58 143.44-22.58S439 346.17 439 346.17"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 361.17s67.38-22.58 143.44-22.58S439 361.17 439 361.17"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 369.17s67.38-24 143.44-24 143.56 24 143.56 24"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 376.42s67.38-23.25 143.44-23.25S439 376.42 439 376.42"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 384.42s67.38-24.5 143.44-24.5S439 384.42 439 384.42"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 399.42s67.38-25.33 143.44-25.33S439 399.42 439 399.42"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 406.42s67.38-25.16 143.44-25.16S439 406.42 439 406.42"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 414.42s67.38-25.75 143.44-25.75S439 414.42 439 414.42"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 423.42s67.38-28 143.44-28 143.56 28 143.56 28"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 438.17s67.38-28.33 143.44-28.33S439 438.17 439 438.17"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 446.17s67.38-29.12 143.44-29.12S439 446.17 439 446.17"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 453.17s67.38-28.41 143.44-28.41S439 453.17 439 453.17"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 460.92s67.38-29.16 143.44-29.16S439 460.92 439 460.92M152 499.92s67.38-32.5 143.44-32.5S439 499.92 439 499.92"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 491.92s67.38-31.58 143.44-31.58S439 491.92 439 491.92"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 484.92s67.38-31.58 143.44-31.58S439 484.92 439 484.92"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 476.92s67.38-31.58 143.44-31.58S439 476.92 439 476.92M152 540.92s67.38-37.75 143.44-37.75S439 540.92 439 540.92"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 532.42s63.38-36.5 143.44-36.5S439 532.42 439 532.42"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 524.67s58.5-35.75 143.5-35.75S439 524.67 439 524.67"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 516.67s60.13-34.75 143.44-34.75S439 516.67 439 516.67M152 556.67s62.13-39 143.44-39 143.56 39 143.56 39"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 566.17s60.75-41.5 143.5-41.5S439 564.92 439 564.92"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 574.42s59.88-43 143.44-43S439 572.92 439 572.92"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 583.42s56.63-44.75 143.44-44.75S439 582.28 439 582.28"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 600.42s58.88-47.5 143.44-47.5S439 599.42 439 599.42"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 610.17s56.25-50.25 143.5-50.25S439 608.17 439 608.17"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 618.17s58.13-50.5 143.44-50.5S439 617.17 439 617.17"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 627.17s60-52.75 143.44-52.75S439 625.68 439 625.68"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 646.68s56.66-57.51 143.44-57.51S439 645.67 439 645.67"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 656.67s55.13-60.5 143.44-60.5S439 655.67 439 655.67"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 667.17s51.62-62.89 143.5-62.89S439 665.92 439 665.92"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 678.92s47.67-67.75 143.44-67.75S439 677.67 439 677.67"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M152 702.42s45.12-76.74 143.64-76.74S439 701.17 439 701.17"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M156.71 708.43s43.29-76.26 138.75-76.26S435 708.43 435 708.43"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M165.21 708.43s45.13-69.26 130.19-69.26 131.31 69.26 131.31 69.26"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M174 708.43s44.66-62.38 121.64-62.38 122.61 62.38 122.61 62.38"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M192 708.43s36-47.26 103.4-47.26 104.06 47.26 104.06 47.26"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M201.46 708.43s34.13-40.15 93.94-40.15 94.81 40.15 94.81 40.15"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M212 708.43s33.13-33.51 83.44-33.51 84.31 33.51 84.31 33.51"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M222.71 708.43s28.14-25.76 72.75-25.76 73.25 25.76 73.25 25.76"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M295.4 80.09v609.19M277.06 690.98L170.73 91.02M232.73 82.89l44.33 500.53M258.48 696.23L151.96 404.17M151.96 490.17l52.3 113.11M151.96 550.2l89.48 154.36M220.71 708.43l-68.75-80.76M151.96 677.24l37.25 31.19M172.08 621.85l-20.12-28.93M239.74 590.04l-87.78-326.76M358.09 82.89L314.2 583.28M314.2 690.98L420.16 91.02M438.96 263.28l-87.88 326.76M332.71 696.06l106.25-292.89M438.96 490.17l-53.12 112.75M438.96 548.73l-89.37 154.91M369.96 708.43l69-82.26M418.21 621.45l20.75-28.53M400.71 708.43l38.25-32.51"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_101",
    d: "M151.96 716.42h287M151.96 723.67h287M438.96 731.17h-287M438.96 738.42h-287M151.96 753.55h287M438.96 760.67h-287M438.96 768.42h-287M438.96 775.92h-287M153.96 708.43v69.99M161.45 708.29v70M168.96 708.43v69.99M176.82 708.29v70M183.96 708.43v69.99M191.25 708.29v70M198.56 708.43v69.99M206.21 708.29v70M213.84 708.29v70M228.25 708.29v70M235.56 708.43v69.99M243.21 708.29v70M250.84 708.29v70M265.81 708.29v70M273.12 708.43v69.99M280.77 708.29v70M288.39 708.29v70M302.81 708.29v70M310.12 708.43v69.99M317.77 708.29v70M325.39 708.29v70M340.24 708.29v70M347.55 708.43v69.99M355.21 708.29v70M362.83 708.29v70M377.24 708.29v70M384.55 708.43v69.99M392.21 708.29v70M399.83 708.29v70M414.62 708.29v70M421.93 708.43v69.99M429.59 708.29v70M437.21 708.29v70M151.96 701.59l11 6.84M151.96 693.92l20.83 14.37M181.13 708.29l-29.17-22.37M151.96 638.59l63.33 69.84M208.96 708.29l-57-58.87M151.96 659.59l51 48.84M196.7 708.43l-44.74-39.34M154.32 635.73l-2.36-2.81M151.96 614.42l74 94.01M230.96 708.43l-79-107.67M235.46 708.29l-83.5-123.24M238.56 706.4l-86.6-138.73M160.05 630.86l-8.09-9.44M166.12 626.14l-14.16-17.88M178.11 617.2l-26.15-40.53M184.63 613.76l-32.67-54.5M151.96 528.59l93.16 173.83M248.29 700.75l-96.33-196.33M151.96 539.42l39.5 70.41M197.81 606.45l-45.85-89.78M251.5 699.19l-99.54-223.06M151.96 460.34l59.45 139.7M254.89 697.68L151.96 443.26M151.96 425.43l66.31 171.78M262.02 694.94L151.96 357.17M151.96 381.26l73.39 213.32M232.73 592.11l-80.77-263.52M151.96 299.09l114 394.83M269.52 692.67L151.96 224.1M151.96 178.28l95.02 409.89M254.5 586.51L158.14 93.42M182.86 88.98l79.16 496.16M269.52 584.05L207.78 85.5M245.3 81.89l42.33 607.7M283.96 689.94L220.07 84.11M195.25 87.14l85.21 602.8M272.79 691.67L151.96 124.6M257.62 81.12l26.34 501.62M270.34 80.55l21.12 608.81M291.46 582.74l-8.5-502.65M307.71 80.2l-8.5 502.22M299.21 689.36l21.25-608.81M333.2 81.12l-26.37 501.62M302.96 689.59l42.55-607.7M370.76 84.11l-63.82 605.83M310.38 690.39L395.6 87.14M383.06 85.5l-61.79 498.55M328.77 585.14l79.24-496.16M432.05 93.28l-95.9 493.2M317.47 691.67l121.49-569.25M438.96 177.09l-95.13 411.08M321.27 692.83l117.69-472.15M438.96 295.92L325.24 693.35M328.77 694.71l110.19-338.95M438.96 325.76l-80.87 266.41M365.48 594.58l73.48-213.32M438.96 423.42l-66.4 173.79M438.96 443.26L335.8 697.22M339.23 698.62l99.73-224.45M438.96 458.97l-59.53 141.07M438.96 503.17l-96.55 196.87M345.67 701.59l93.29-174.53M438.96 515.17l-46.65 90.91M399.46 609.83l39.5-71.16M438.96 558.17l-32.73 55.59M438.96 567.67l-85.97 137.34M356.03 707.46l82.93-123.41M438.96 576.67L412.4 617.2M359.46 708.43l79.5-108.63M438.96 606.45l-14.18 19.69M438.96 613.76l-74.83 94.67M438.96 620.09l-8.58 10.39M438.96 632.17l-3.04 2.96M374.96 708.43l64-70.26M438.96 648.09l-58.17 60.2M386.63 708.43l52.33-50.17M438.96 667.3l-45.67 40.99M438.96 684.8l-30 23.63M416.13 708.43l22.83-15.6M438.96 700.04l-13.28 8.39M435.92 708.43l3.04-2.03"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 94.46h-8.67M457.96 101.92h-8.67"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 87.01h-5.5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 108.92h-8.67M457.96 115.92h-8.67M457.96 123.17h-12.58M457.96 130.46h-8.67M457.96 137.92h-8.67M457.96 144.92h-8.67M457.96 151.92h-8.67M457.96 167.05h-8.67M457.96 174.52h-8.67M457.96 181.52h-8.67M457.96 188.52h-8.67M457.96 195.77h-12.58M457.96 203.05h-8.67M457.96 210.52h-8.67M457.96 217.52h-8.67M457.96 224.52h-8.67"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 159.67h-5.5M457.96 232.3h-5.5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 240.05h-8.67M457.96 247.52h-8.67M457.96 254.52h-8.67M457.96 261.52h-8.67M457.96 268.77h-12.58M457.96 276.05h-8.67M457.96 283.52h-8.67M457.96 290.52h-8.67M457.96 297.52h-8.67"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 305.3h-5.5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 312.55h-8.67M457.96 320.02h-8.67M457.96 327.02h-8.67M457.96 334.02h-8.67M457.96 341.27h-12.58M457.96 348.55h-8.67M457.96 356.02h-8.67M457.96 363.02h-8.67M457.96 370.02h-8.67"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 377.8h-5.5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 385.55h-8.67M457.96 393.02h-8.67M457.96 400.02h-8.67M457.96 407.02h-8.67M457.96 414.27h-12.58M457.96 421.55h-8.67M457.96 429.02h-8.67M457.96 436.02h-8.67M457.96 443.02h-8.67"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 450.8h-5.5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 458.55h-8.67M457.96 466.02h-8.67M457.96 473.02h-8.67M457.96 480.02h-8.67M457.96 487.27h-12.58M457.96 494.55h-8.67M457.96 502.02h-8.67M457.96 509.02h-8.67M457.96 516.02h-8.67"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 523.8h-5.5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 531.55h-8.67M457.96 539.02h-8.67M457.96 546.02h-8.67M457.96 553.02h-8.67M457.96 560.27h-12.58M457.96 567.55h-8.67M457.96 575.02h-8.67M457.96 582.02h-8.67M457.96 589.02h-8.67"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 596.8h-5.5"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 603.55h-8.67M457.96 611.02h-8.67M457.96 618.02h-8.67M457.96 625.02h-8.67M457.96 632.27h-12.58M457.96 639.55h-8.67M457.96 647.02h-8.67M457.96 654.02h-8.67M457.96 661.02h-8.67"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 668.8h-5.5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 676.55h-8.67M457.96 684.02h-8.67M457.96 691.02h-8.67M457.96 698.02h-8.67M457.96 705.27h-12.58M457.96 712.55h-8.67M457.96 720.02h-8.67M457.96 727.02h-8.67M457.96 734.02h-8.67"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_99",
    d: "M457.96 741.8h-5.5"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "crp5_100",
    d: "M457.96 749.02h-8.67M457.96 756.02h-8.67"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 84.73) rotate(90)"
  }, "0")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 157.73) rotate(90)"
  }, "1")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 229.92) rotate(90)"
  }, "2")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 302.92) rotate(90)"
  }, "3")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 375.92) rotate(90)"
  }, "4")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 448.92) rotate(90)"
  }, "5")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 521.92) rotate(90)"
  }, "6")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 594.92) rotate(90)"
  }, "7")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 666.92) rotate(90)"
  }, "8")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_97",
    transform: "translate(443.09 739.92) rotate(90)"
  }, "9")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(441.81 95.48) rotate(90)",
    fontSize: 8.27,
    fontFamily: "HelveticaNeue-Condensed, Helvetica Neue",
    fill: "#1d1d1b"
  }, "inches")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_102",
    transform: "translate(165.1 87.92) rotate(-10.34)"
  }, "10")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_102",
    transform: "translate(229.38 78.44) rotate(-5.71)"
  }, "5")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_102",
    transform: "translate(415.18 86.42) rotate(8.56)"
  }, "10")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_102",
    transform: "matrix(1, 0.05, -0.05, 1, 355.51, 79.02)"
  }, "5")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(284.53 76.26)"
  }, "1000")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 113.26)"
  }, "950")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 148.26)"
  }, "900")), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 184.26)"
  }, "850")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 219.26)"
  }, "800")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 256.26)"
  }, "750")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 292.26)"
  }, "700")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 327.26)"
  }, "650")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 363.26)"
  }, "600")), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 398.26)"
  }, "550")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 435.26)"
  }, "500")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 470.26)"
  }, "450")), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 506.26)"
  }, "400")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 541.26)"
  }, "350")), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 578.26)"
  }, "300")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 614.26)"
  }, "250")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 649.26)"
  }, "200")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 686.26)"
  }, "150")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(289.97 738.26)"
  }, "50")), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(287.25 775.26)"
  }, "100")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(177.36 380.05) rotate(-14.81)"
  }, "15")), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(214.6 371.19) rotate(-12.14)"
  }, "10")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "matrix(1, -0.08, 0.08, 1, 255.32, 364.58)"
  }, "5")), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(402.16 376.67) rotate(11.56)"
  }, "15")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(364.78 368.45) rotate(9.31)"
  }, "10")), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(330.86 364.1) rotate(4.93)"
  }, "5")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(214.82 518.04) rotate(-14.81)"
  }, "15")), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(239.81 512.3) rotate(-12.14)"
  }, "10")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "matrix(1, -0.08, 0.08, 1, 267.32, 507.58)"
  }, "5")), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "matrix(0.98, 0.22, -0.22, 0.98, 365.4, 515.39)"
  }, "15")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(340.24 510.31) rotate(9.31)"
  }, "10")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(317.86 507.1) rotate(4.93)"
  }, "5")), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(190.46 526.36) rotate(-20.04)"
  }, "20")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(166.9 535.95) rotate(-23.32)"
  }, "25")), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(389.92 522) rotate(19.52)"
  }, "20")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(412.28 530.7) rotate(23.1)"
  }, "25")), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(239.46 660.05) rotate(-20.04)"
  }, "20")), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(216.52 672.72) rotate(-28.7)"
  }, "30")), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(196.4 687.84) rotate(-38.67)"
  }, "40")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "matrix(0.65, -0.76, 0.76, 0.65, 178.71, 707.27)"
  }, "50")), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(263.91 653.57) rotate(-11.31)"
  }, "10")), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(315.6 651.61) rotate(9.31)"
  }, "10")), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(340.59 656.24) rotate(21.12)"
  }, "20")), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(364.28 667.82) rotate(28.03)"
  }, "30")), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(385.57 680.97) rotate(40.86)"
  }, "40")), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(405.38 698.8) rotate(45.17)"
  }, "50")), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "matrix(0.99, -0.15, 0.15, 0.99, 189.7, 229.01)"
  }, "10")), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "matrix(1, -0.08, 0.08, 1, 242.23, 222.68)"
  }, "5")), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(390.18 227.34) rotate(9.31)"
  }, "10")), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_105",
    transform: "translate(342.77 221.21) rotate(4.93)"
  }, "5")), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 113.26)"
  }, "950")), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 148.26)"
  }, "900")), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 184.26)"
  }, "850")), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 219.26)"
  }, "800")), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 256.26)"
  }, "750")), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 292.26)"
  }, "700")), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 327.26)"
  }, "650")), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 363.26)"
  }, "600")), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 398.26)"
  }, "550")), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 435.26)"
  }, "500")), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 470.26)"
  }, "450")), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 506.26)"
  }, "400")), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 541.26)"
  }, "350")), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 578.26)"
  }, "300")), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 614.26)"
  }, "250")), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 649.26)"
  }, "200")), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 686.26)"
  }, "150")), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(289.97 738.26)"
  }, "50")), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(287.25 775.26)"
  }, "100")), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(177.36 380.05) rotate(-14.81)"
  }, "15")), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(214.6 371.19) rotate(-12.14)"
  }, "10")), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "matrix(1, -0.08, 0.08, 1, 255.32, 364.58)"
  }, "5")), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(402.16 376.67) rotate(11.56)"
  }, "15")), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(364.78 368.45) rotate(9.31)"
  }, "10")), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(330.86 364.1) rotate(4.93)"
  }, "5")), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(214.82 518.04) rotate(-14.81)"
  }, "15")), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(239.81 512.3) rotate(-12.14)"
  }, "10")), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "matrix(1, -0.08, 0.08, 1, 267.32, 507.58)"
  }, "5")), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "matrix(0.98, 0.22, -0.22, 0.98, 365.4, 515.39)"
  }, "15")), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(340.24 510.31) rotate(9.31)"
  }, "10")), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(317.86 507.1) rotate(4.93)"
  }, "5")), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(190.46 526.36) rotate(-20.04)"
  }, "20")), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(166.9 535.95) rotate(-23.32)"
  }, "25")), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(389.92 522) rotate(19.52)"
  }, "20")), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(412.28 530.7) rotate(23.1)"
  }, "25")), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(239.46 660.05) rotate(-20.04)"
  }, "20")), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(216.52 672.72) rotate(-28.7)"
  }, "30")), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(196.4 687.84) rotate(-38.67)"
  }, "40")), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "matrix(0.65, -0.76, 0.76, 0.65, 178.71, 707.27)"
  }, "50")), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(263.91 653.57) rotate(-11.31)"
  }, "10")), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(315.6 651.61) rotate(9.31)"
  }, "10")), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(340.59 656.24) rotate(21.12)"
  }, "20")), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(364.28 667.82) rotate(28.03)"
  }, "30")), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(385.57 680.97) rotate(40.86)"
  }, "40")), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(405.38 698.8) rotate(45.17)"
  }, "50")), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "matrix(0.99, -0.15, 0.15, 0.99, 189.7, 229.01)"
  }, "10")), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "matrix(1, -0.08, 0.08, 1, 242.23, 222.68)"
  }, "5")), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(390.18 227.34) rotate(9.31)"
  }, "10")), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "crp5_104",
    transform: "translate(342.77 221.21) rotate(4.93)"
  }, "5")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp5SpeedscaleHigh);
export default __webpack_public_path__ + "static/media/crp5-speedscale-high.e0c98a5ec658d61b99a7add9af55b7db.svg";
export { ForwardRef as ReactComponent };